import { Injectable } from '@angular/core';
import { Network } from '@ionic-native/network';
import { Platform } from 'ionic-angular';


@Injectable()
export class NetworkService {

  connected: boolean = true;

  constructor(private network: Network, private platform: Platform) {}

	init(): void {
		this.platform.ready().then(() => {
			if (this.platform.is('cordova')) {
				setTimeout(() => {
					if(this.network.type !== 'none') {
						this.connected = true;
					}
					else {
						this.connected = false;
					}
				}, 3000);

				this.network.onDisconnect().subscribe(() => {
					this.connected = false;
				});

				this.network.onConnect().subscribe(() => {
					this.connected = true;
				});
			}
    });
	}

}



// WEBPACK FOOTER //
// ./src/services/network.service.ts